import axios from "axios";

const setAuthToken = (token, deviceInfo) => {
  if (token) {
    // Apply to every request
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    if (deviceInfo) {
      axios.defaults.headers.common["deviceInfo"] = JSON.stringify(deviceInfo);
    }
  } else {
    // Delete auth header
    delete axios.defaults.headers.common["Authorization"];
    if (deviceInfo) {
      axios.defaults.headers.common["deviceInfo"] = JSON.stringify(deviceInfo);
    }
  }
};

export default setAuthToken;
